import React from 'react'
import styles from './ImageBlock.scss'
import {Block} from 'features/ride_reports/EditPage/ReportEditor/Block'
import {removeBlock} from 'lib/blockUtils'
import {EditorState} from 'draft-js'
import {request} from 'lib/apiv3/utils/request'
import {showModal, updateModalProps} from 'lib/modalUtils'
import {INSERT_IMAGE_MODAL} from 'common/modals/InsertImageModal'
import cx from 'classnames'

export class ImageBlock extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      savePending: false,
      imageVersion: 1 // add to querystring to bust browser cache on image update
    }
  }

  hasImage = () => !!this.props.block.getData().get('photoId')

  componentDidUpdate (prevProps) {
    const {blockProps, block} = this.props
    const {isSelected} = blockProps
    if (!isSelected && !block.getData().get('photoId')) {
      this.removeSelf()
    }
  }

  onDrop = (files) => {
    const {block, blockProps: {resetEditorMode, guide}} = this.props
    resetEditorMode() // pull the editor out of drag mode, since it doesn't get the drop event

    if (files && files[0]) {
      const pendingFile = files[0]
      const photoId = block.getData().get('photoId')
      const body = new window.FormData()
      body.append('file', pendingFile)
      const requestOpts = {
        headers: { 'content-type': undefined },
        body
      }
      let promise
      if (photoId) {
        promise = request.patch(`/photos/${photoId}.json`, requestOpts)
      } else {
        body.append('parent_type', 'experience_guide_page')
        body.append('parent_id', guide.id)
        promise = request.post(`/photos.json`, requestOpts)
      }
      promise.then(({photo}) => {
        this.props.blockProps.onChange({photoId: photo.id})
        const imageVersion = this.state.imageVersion + 1

        updateModalProps({savePending: false, image: `/photos/${photo.id}/large.jpg?${imageVersion}`})
        this.setState({savePending: false, imageVersion})
      })
      updateModalProps({savePending: true})
      this.setState({savePending: true})
    }
  }

  removeSelf = () => {
    const {blockProps: {getEditorState, setEditorState}, block} = this.props
    const contentState = getEditorState().getCurrentContent()
    setEditorState(EditorState.push(getEditorState(), removeBlock(contentState, block.getKey()), 'remove-range'))
  }

  showInsertModal = () => {
    const {savePending, imageVersion} = this.state
    const data = this.props.block.getData()
    const photoId = data.get('photoId', null)
    const image = photoId ? `/photos/${photoId}/large.jpg?${imageVersion}` : null

    showModal(INSERT_IMAGE_MODAL, {
      image,
      onDrop: this.onDrop,
      imageType: data.get('imageType', 'static'),
      imageUrl: data.get('imageUrl', ''),
      saveImageTypeAndUrl: (v) => this.saveImageTypeAndUrl(v),
      savePending: savePending,
      maybeRemoveSelf: () => {
        if (!this.hasImage()) {
          this.removeSelf()
        }
      }
    })
  }

  saveImageTypeAndUrl = ({imageType, imageUrl}) => {
    this.props.blockProps.onChange({imageType, imageUrl})
  }

  render () {
    const {blockProps, block} = this.props
    const {imageVersion} = this.state
    const {isSelected} = blockProps
    const data = this.props.block.getData()
    const photoId = data.get('photoId', null)
    const image = photoId ? `/photos/${photoId}/large.jpg?${imageVersion}` : null

    if (isSelected && !photoId) {
      this.showInsertModal()
    }

    return (
      <Block size='bigBlock' blockProps={blockProps} block={block} grabFocusOnUpdate={false}>
        <div className={styles.children}>
          {image
            ? <div className={styles.contents}>
              <img src={image} className={styles.blockImg} />
              {isSelected && <div className={styles.actions}>
                <a onClick={() => this.showInsertModal()}>Edit</a>
                <a onClick={() => this.removeSelf()}>Delete</a>
              </div>}
            </div>
            : <div className={cx(styles.selected, styles.empty)} /> }
        </div>
      </Block>
    )
  }
}
